module.exports = new __parcel__URL__("mouse.3d0aefe8.svg").toString();